import './video-modal.scss';

/**
 * Extract the 11-char YouTube video ID from various URL formats.
 *
 * @param {string} url YouTube URL
 * @return {string|null} Video ID or null
 */
function extractYouTubeId( url ) {
	if ( ! url ) {
		return null;
	}

	const patterns = [
		/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
		/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
	];

	for ( const pattern of patterns ) {
		const match = url.match( pattern );

		if ( match ) {
			return match[ 1 ];
		}
	}

	return null;
}

let modal = null;
let iframe = null;

function createModal() {
	if ( modal ) {
		return;
	}

	modal = document.createElement( 'div' );
	modal.className = 'p-videoModal';
	modal.setAttribute( 'aria-hidden', 'true' );

	const backdrop = document.createElement( 'div' );
	backdrop.className = 'p-videoModal__backdrop';
	backdrop.addEventListener( 'click', closeModal );

	const content = document.createElement( 'div' );
	content.className = 'p-videoModal__content';

	const closeBtn = document.createElement( 'button' );
	closeBtn.className = 'p-videoModal__close';
	closeBtn.setAttribute( 'aria-label', 'Sluiten' );
	closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
		'<path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
		'</svg>';
	closeBtn.addEventListener( 'click', closeModal );

	iframe = document.createElement( 'iframe' );
	iframe.className = 'p-videoModal__iframe';
	iframe.setAttribute( 'allowfullscreen', '' );
	iframe.setAttribute( 'allow', 'autoplay; encrypted-media' );
	iframe.setAttribute( 'frameborder', '0' );

	content.appendChild( closeBtn );
	content.appendChild( iframe );
	modal.appendChild( backdrop );
	modal.appendChild( content );
	document.body.appendChild( modal );
}

function openModal( youtubeUrl ) {
	createModal();

	const videoId = extractYouTubeId( youtubeUrl );

	if ( ! videoId ) {
		return;
	}

	iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
	modal.setAttribute( 'aria-hidden', 'false' );
	modal.classList.add( '-active' );
	document.body.style.overflow = 'hidden';
	document.addEventListener( 'keydown', handleEscape );
}

function closeModal() {
	if ( ! modal ) {
		return;
	}

	iframe.src = '';
	modal.setAttribute( 'aria-hidden', 'true' );
	modal.classList.remove( '-active' );
	document.body.style.overflow = '';
	document.removeEventListener( 'keydown', handleEscape );
}

function handleEscape( e ) {
	if ( e.key === 'Escape' ) {
		closeModal();
	}
}

function initVideoModal() {
	document.addEventListener( 'click', ( e ) => {
		const trigger = e.target.closest( '[data-video-modal]' );

		if ( ! trigger ) {
			return;
		}

		e.preventDefault();

		const url = trigger.getAttribute( 'data-video-modal' );
		openModal( url );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initVideoModal );
} else {
	initVideoModal();
}
